import { Controller } from "@hotwired/stimulus"

// Generic hover/focus tooltip. Pair a trigger element with
// data-action="mouseenter->tooltip#show mouseleave->tooltip#hide
// focus->tooltip#show blur->tooltip#hide" with a data-tooltip-target="bubble"
// element holding the tooltip text.
//
// Add "click->tooltip#toggle" to the trigger to let a click pin the bubble
// open, so it can hold a link: hover/blur no longer hide it until the trigger
// is clicked again, the user clicks elsewhere, or presses Escape.
export default class extends Controller {
  static targets = ["bubble"]

  connect() {
    this.pinned = false
    this.closeOnOutsideClick = (event) => {
      if (this.pinned && !this.element.contains(event.target)) this.close()
    }
    this.closeOnEscape = (event) => {
      if (this.pinned && event.key === "Escape") this.close()
    }
    document.addEventListener("click", this.closeOnOutsideClick)
    document.addEventListener("keydown", this.closeOnEscape)
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnOutsideClick)
    document.removeEventListener("keydown", this.closeOnEscape)
  }

  show() {
    this.bubbleTarget.classList.remove("hidden")
  }

  hide() {
    if (!this.pinned) this.bubbleTarget.classList.add("hidden")
  }

  toggle() {
    if (this.pinned) {
      this.close()
    } else {
      this.pinned = true
      this.show()
    }
  }

  close() {
    this.pinned = false
    this.bubbleTarget.classList.add("hidden")
  }
}
